// import React, { useState } from "react";
// import { Box, Typography, IconButton, Link } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const RiskBanner = () => {
//     const [visible, setVisible] = useState(() => {
//         return localStorage.getItem("riskAccepted") !== "true";
//     });

//     const handleClose = () => {
//         localStorage.setItem("riskAccepted", "true");
//         setVisible(false);
//     };

//     if (!visible) return null;

//     return (
//         <Box
//             sx={{
//                 position: "fixed",
//                 bottom: 20,
//                 left: 45,
//                 width: "95%",
//                 backgroundColor: "#1A1C1E",
//                 color: "#fff",
//                 px: { xs: 2, sm: 4 },
//                 py: 1.5,
//                 zIndex: 1500,
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 borderRadius: "20px"
//             }}
//         >
//             <Typography
//                 variant="body2"
//                 sx={{ color: "#fff", fontSize: "14px", mr: 2 }}
//             >
//                 <strong>Risk Warning:</strong> Your capital is at risk. Leveraged
//                 products may not be suitable for everyone. Please consider our{" "}
//                 <Link
//                     href="https://cloud.xm-cdn.com/static/pdf/System-PDFs/XMGlobal-Risk-Disclosures-for-Financial-Instruments.pdf?v=119773c37701038236cd27960273ea9d"
//                     target="_blank"
//                     rel="noopener"
//                     underline="none" // disables default underline
//                     sx={{
//                         color: "#fff",
//                         textDecoration: "none",
//                         fontWeight: 500,
//                         "&:hover": {
//                             textDecoration: "underline",  // enable underline on hover
//                             color: "#fff",             // optional: change color on hover
//                         },
//                     }}
//                 >
//                     Risk Disclosure
//                 </Link>

//                 .
//             </Typography>
//             <IconButton
//                 onClick={handleClose}
//                 size="medium"
//                 sx={{
//                     color: "#fff",
//                     backgroundColor: "rgba(255,255,255,0.1)",
//                     ml: 1,
//                     "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
//                 }}
//             >
//                 <CloseIcon fontSize="small" />
//             </IconButton>
//         </Box>
//     );
// };

// export default RiskBanner;

import React, { useState } from "react";
import { Box, Typography, IconButton, Link, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RiskBanner = () => {
  const [visible, setVisible] = useState(() => {
    return localStorage.getItem("riskAccepted") !== "true";
  });

  const handleClose = () => {
    localStorage.setItem("riskAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        width: { xs: "90%", sm: "95%", md: "90%" },
        backgroundColor: "#1A1C1E",
        color: "#fff",
        px: { xs: 2, sm: 4 },
        py: { xs: 1.5, sm: 2 },
        zIndex: 1500,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1,
        borderRadius: "16px",
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#fff",
          fontSize: { xs: "13px", sm: "14px" },
          lineHeight: 1.6,
          flex: 1,
        }}
      >
        <strong>Risk Warning:</strong> Your capital is at risk. Leveraged
        products may not be suitable for everyone. Please consider our{" "}
        <Link
          href="/Pdf/newRisk.pdf"
          target="_blank"
          rel="noopener"
          underline="none"
          sx={{
            color: "#fff",
            fontWeight: 500,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "underline",
              color: "#fff",
            },
          }}
        >
          Risk Disclosure
        </Link>
        .
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            //   mt: 6,
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "#fff",
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 500,
            boxShadow: "none",
            ":hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              boxShadow: "none",
              color: "#fff",
            },
          }}
        >
          I understand
        </Button>
      </Box>

      {/* <IconButton
        onClick={handleClose}
        size="medium"
        sx={{
          color: "#fff",
          backgroundColor: "rgba(255,255,255,0.1)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton> */}
    </Box>
  );
};

export default RiskBanner;
